import script from "./AtelierSvg.vue?vue&type=script&setup=true&lang=js"
export * from "./AtelierSvg.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__